let url = window.location.hostname;
let array = url.split(".");
let region = array[1];
if(region!=="eu"){

    let ele = document.getElementById("ExemptifyCartValidationSnippet");
  
  ele.style.display = "none";
    // added by daxanema 05.11.2024
    ele.remove();
  
  let sec=document.getElementById("cart_page_company_name_section");
  sec.style.display = "none";
}

